export default "__VITE_ASSET__CdyNriEG__"